import React from 'react'
import { Layout, Testimonial } from '../components/common'
import {
  CardsSecondary,
  OverviewSection,
  BenefitsSection,
  CallToActionSection,
  MainImage,
  Testimonials,
  BackgroundSectionSecondary
} from '../components/OurCoaches'

const OurCoachesPage = ({ data = {} }) => {
  return (
    <Layout query={data} title='PGA.Coach'>
      <MainImage />
      <Testimonial
        author='- Brian Phelps, PGA Professional'
        blockquote="“This app couldn&#x27;t be simpler to use, it really couldn&#x27;t.
I mean if you&#x27;re not using this you&#x27;re making your life a lot harder... It&#x27;s more valuable than any other tool that I have here.”"
      />
      <OverviewSection />
      <CardsSecondary />
      <BenefitsSection />
      <BackgroundSectionSecondary />
      <Testimonials />
      <CallToActionSection />
    </Layout>
  )
}

export default OurCoachesPage
